import Photo from './photo';

export default function HeroProduct(props) {
    return (
        <section>
            <div className="header-product relative">
                <div className="skew-bottom-right"></div>
                <div className="container !mt-0">
                    <div className="flex flex-col md:flex-row items-center justify-start lg:mt-10">
                        {props.cover.data && (
                            <div className="flex w-3/4 mx-auto md:w-1/2 relative z-20 justify-center">
                                <Photo image={props.cover}></Photo>
                            </div>
                        )}
                        <div className="flex flex-col w-full px-4 pt-0 pb-8 xl:pr-0 md:w-2/3 text-white justify-start">
                            <h1>{props.title}</h1>
                            <span dangerouslySetInnerHTML={{ __html: props.description }}></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
